import _ from 'lodash';

import isVehicleInPriceRange from './is-vehicle-in-price-range';

const UCSR_MAX_VEHICLE_COUNT = 1;
const CARD_PRICE_RANGES = [
  { min: 1, max: 10000 },
  { min: 10000, max: 20000 },
  { min: 20000, max: 30000 },
  { min: 30000, max: 35000 },
];

/**
 * Takes the vehicle results from Algolia and filters them down to show random results that meet certain
 * business requirements.
 *
 * Business rules are:
 *  - Show 4 vehicles
 *  - Should show one vehicle from each of the following price ranges if possible ($0-10k, $10-20k, $20-30k, $30-35k)
 *  - Show 1 vehicle with UCSR rating if available
 *  - Show remaining spots ANCAP rating
 *
 * @param {array} vehicles Vehicle results returned from Algolia
 */
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'vehicles' implicitly has an 'any' type.
const filterResults = (vehicles) => {
  const output = Array(CARD_PRICE_RANGES.length);

  // First shuffle the entire vehicles collection
  const shuffledVehicles = _.shuffle(vehicles);

  // We need to limit UCSR rating vehicles, so store a variable to count
  let ucsrVehiclesRemaining = UCSR_MAX_VEHICLE_COUNT;

  // Loop through the collection, filling up the output array
  _.forEach(shuffledVehicles, (vehicle) => {
    // If we already have enough UCSR vehicles then skip
    if (ucsrVehiclesRemaining === 0 && vehicle.ratingBy === 'UCSR') {
      return;
    }

    // Find out what card this vehicle could populate
    _.forEach(CARD_PRICE_RANGES, (cardPriceRange, index) => {
      if (output[index] && !(ucsrVehiclesRemaining > 0 && vehicle.ratingBy === 'UCSR')) {
        return;
      }

      if (isVehicleInPriceRange(cardPriceRange, vehicle)) {
        output[index] = vehicle;

        if (vehicle.ratingBy === 'UCSR') {
          ucsrVehiclesRemaining -= 1;
        }

        // To break a lodash forEach you need to return false
        return false;
      }
    });

    // Break the loop early if all spaces have been filled
    if (_.every(output, Boolean) && ucsrVehiclesRemaining === 0) {
      return false;
    }
  });

  // Check that all the spaces in output have been filled
  if (_.some(output, _.isUndefined)) {
    _.forEach(output, (selectedVehicle, index) => {
      if (selectedVehicle) {
        return;
      }

      // If there are some gaps pick literally any from the original query
      const remainingVehicles = _.filter(shuffledVehicles, (vehicle) => _.indexOf(output, vehicle) < 0);
      output[index] = _.head(remainingVehicles);
    });
  }

  return _.compact(output);
};

export default filterResults;
export { CARD_PRICE_RANGES, UCSR_MAX_VEHICLE_COUNT };
